var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreaterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M19.3913 16.5206C19.7806 16.1751 19.9995 15.7062 20 15.2172V14.2828C19.9936 13.7948 19.7756 13.3279 19.3913 12.9794L5.17013 0.363713C4.91038 0.130934 4.55679 0 4.18793 0C3.81906 0 3.46548 0.130934 3.20572 0.363713L1.24132 2.10974C0.981066 2.33639 0.834407 2.64661 0.834407 2.97046C0.834407 3.29431 0.981066 3.60453 1.24132 3.83118L13.5534 14.75L1.24132 25.6688C0.979427 25.8997 0.832116 26.214 0.832116 26.5418C0.832116 26.8697 0.979427 27.184 1.24132 27.4149L3.20572 29.1363C3.46548 29.3691 3.81906 29.5 4.18793 29.5C4.55679 29.5 4.91038 29.3691 5.17013 29.1363L19.3913 16.5206Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterIcon);
export default __webpack_public_path__ + "static/media/greaterIcon.68f1b1d436c561fb7d3e12ffafb5f90f.svg";
export { ForwardRef as ReactComponent };